import { ReportReviewView } from "@api/graphql/types-and-hooks";

export const WAITING_ON_YOU = "Waiting on you";
export const SENT_BACK_TO_YOU = "Sent back to you";
export const IN_REVIEW = "In review";
export const REVIEWED_BY_YOU = "Reviewed by you";

export const REVIEW_VIEW_LABELS: Record<ReportReviewView, string> = {
  [ReportReviewView.WaitingOnMe]: WAITING_ON_YOU,
  [ReportReviewView.SentBackToMe]: SENT_BACK_TO_YOU,
  [ReportReviewView.InReview]: IN_REVIEW,
  [ReportReviewView.ReviewedByMe]: REVIEWED_BY_YOU,
};

/** Filter option order. */
export const REVIEW_VIEWS: ReportReviewView[] = [
  ReportReviewView.WaitingOnMe,
  ReportReviewView.SentBackToMe,
  ReportReviewView.InReview,
  ReportReviewView.ReviewedByMe,
];

export const REVIEW_PARAM = "review";

export const REVIEW_PARAM_BY_VIEW: Record<ReportReviewView, string> = {
  [ReportReviewView.WaitingOnMe]: "waiting",
  [ReportReviewView.SentBackToMe]: "sent-back",
  [ReportReviewView.InReview]: "in-review",
  [ReportReviewView.ReviewedByMe]: "reviewed",
};
